import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import ProductItemTitles from '../Shared/ProductItemTitles';
import {isMobile} from 'react-device-detect';
import {ColumnHtml, ColumnTwoPartsHtml, ColumnHtmlWithIcon, DataUsageHtml} from '../Shared/sharedHtmlComponents';
import {productStatus, openMabalSubscribersPopup, popupTypes} from '../productsAndServicesBlockSlice';
import ProductStatus from '../Shared/ProductStatus';
import CategoryName from '../Shared/CategoryName';
const MabalItem = (props) => {
  const itemTitles = ['חבילה', ''];
  const widthList = ['20', '80'];

  return (
    <div className={`productAndServicesItemContainer ${props.type}`}>
      <CategoryName
        title={'שיחות בינלאומיות'}
        imageName={`${isMobile ? 'international-calls' : 'international-calls-desc'}`}
        goToAction={props.goToAction}
        actions={props.mabalActions}
      />
      {!isMobile && <ProductItemTitles titlesList={itemTitles} widthList={widthList} />}
      {props.mabalItems?.map((mabalItem, index) => {
        const status =
          mabalItem.productStatus == productStatus.BUSINESS ||
          mabalItem.productStatus == productStatus.CANCELLED ||
          mabalItem.productStatus == productStatus.SUSPENDED
            ? mabalItem.productStatus
            : null;
        return (
          <div key={index}>
            {!isMobile ? (
              <div className='productAndServicesItemContainer_content_wrapper d-flex'>
                {status && <ProductStatus status={status} />}
                <ColumnHtml item={mabalItem.packageName} columnWidth={widthList[0]} />
                {/* <ColumnHtmlWithIcon
                  item={mabalItem.packageName}
                  columnWidth={widthList[1]}
                  // buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}??
                  buttonAction={() => console.log('click')}
                /> */}
                <ColumnHtmlWithIcon
                  item={'טלפונים הרשומים לשירות'}
                  columnWidth={widthList[1]}
                  buttonAction={() => props.openMabalSubscribersPopup(mabalItem.psId)}
                />
              </div>
            ) : (
              <div className='productAndServicesItemContainer_content_wrapper'>
                <ColumnTwoPartsHtml titleCustomClass={'semiBold black'} textCustomClass={'status'}>
                  {status && <ProductStatus status={status} />}
                </ColumnTwoPartsHtml>
                <ColumnTwoPartsHtml title={itemTitles[0]}>
                  <ColumnHtml item={mabalItem.packageName} />
                </ColumnTwoPartsHtml>
                <ColumnHtmlWithIcon item={'טלפונים הרשומים לשירות'} buttonAction={() => props.openMabalSubscribersPopup(mabalItem.psId)} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  openMabalSubscribersPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(MabalItem);
